const CompanyProperties = {
	FEATURE_BANKBOOK: 'bankBook'
};

export default CompanyProperties;
